// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__R804i","title":"SectionHeader_title__mpLvB","subTitle":"SectionHeader_subTitle__gE+P0","stepStatus":"SectionHeader_stepStatus__d-2V7"};